module.exports = __webpack_public_path__ + "img/b-4.22.2507f2b0.jpg";